module.exports = __webpack_public_path__ + "static/media/cgt-logo-rouge.3428b684.svg";